import createPartnerActivity from "../utils/createPartnerActivity";

/**
 * Finds tours or activites off of a place
 * @param  {object} A place object off of the state
 * @param  {array} activities An array of activities
 * @return {object} An object containing either a tour or an activity
 */
export default function selectActivity({ activities = [] }) {
  if (activities.length) {
    const mapped = activities.map(a => createPartnerActivity(a));
    const activitiesWithImages = mapped.filter(a => a.type === "activity" && a.image);
    const toursWithImages = mapped.filter(a => a.type === "tour" && a.image);
    const results = {};

    if (activitiesWithImages.length) {
      results.activity = activitiesWithImages[0];
    }

    if (toursWithImages.length) {
      results.tour = toursWithImages[0];
    }

    return results;
  }

  return { activity: null, tour: null };
}

export const getToursAndActivities = state => {
  const poi = state.pois.initial;

  if (!poi || !poi.partnerActivities) {
    return [];
  }

  const activities = [
    ...poi.partnerActivities.activities,
    ...poi.partnerActivities.tours,
  ];

  return selectActivity({ activities });
};



// WEBPACK FOOTER //
// ./assets/pois/selectors/selectActivity.js